module.exports = __webpack_public_path__ + "img/logo_icon_white.e50f1279.png";